import { render } from "./UserMenu.vue?vue&type=template&id=562c5780&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"

import "./UserMenu.vue?vue&type=style&index=0&id=562c5780&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562c5780"]])

export default __exports__